import React from "react";
import "./Legal.css";
import logoBota from "../../assets/img/Frame.png";
import backgroundLogo from "../../assets/img/backgroundLogo.jpg";

export default function TermsOfService() {
  return (
    <div
      className='legal-page'
      style={{ backgroundImage: `url(${backgroundLogo})` }}
    >
      <div className='legal-inner'>
        <a href='/login' className='legal-back'>&larr; Quay lại đăng nhập</a>
        <div className='legal-card'>
          <div className='legal-card-body'>
            <div className='legal-header'>
              <a href='/login' className='legal-logo'>
                <img src={logoBota} alt='Bota.vn' style={{ maxHeight: 52 }} />
              </a>
              <h1 className='legal-title'>Điều khoản dịch vụ</h1>
              <div className='legal-updated'>Cập nhật lần cuối: 01/03/2026</div>
            </div>

            <div className='legal-content'>
              <p>
                Chào mừng bạn đến với connect.mybota.vn — nền tảng quản lý bán hàng đa kênh do Bota.vn xây dựng.
                Điều khoản dịch vụ này quy định việc sử dụng connect.mybota.vn. Bằng việc đăng ký và sử dụng dịch vụ,
                bạn đồng ý với các điều khoản dưới đây.
              </p>

              <h2>1. Điều khoản chung</h2>
              <p>
                connect.mybota.vn cung cấp công cụ đồng bộ đơn hàng, sản phẩm, kho hàng giữa các sàn
                thương mại điện tử (Shopee, Lazada, TikTok Shop, Sendo) và tích hợp vận chuyển
                với các đơn vị giao hàng (GHN, Viettel Post, Grab Express, v.v.). Bạn có trách nhiệm
                tuân thủ pháp luật Việt Nam và quy định của từng sàn/đơn vị vận chuyển khi sử dụng dịch vụ.
              </p>

              <h2>2. Tài khoản</h2>
              <p>Khi tạo tài khoản, bạn cam kết:</p>
              <ul>
                <li>Cung cấp thông tin chính xác, đầy đủ và cập nhật khi có thay đổi.</li>
                <li>Bảo mật mật khẩu và không chia sẻ tài khoản với bên thứ ba.</li>
                <li>Chịu trách nhiệm về mọi hoạt động diễn ra dưới tài khoản của bạn.</li>
              </ul>
              <p>
                Chúng tôi (Bota.vn) có quyền đình chỉ hoặc khóa tài khoản nếu phát hiện vi phạm điều khoản
                hoặc hành vi bất thường gây rủi ro cho hệ thống hoặc người dùng khác.
              </p>

              <h2>3. Dịch vụ</h2>
              <p>
                Chúng tôi nỗ lực duy trì dịch vụ ổn định nhưng không đảm bảo dịch vụ không bị gián đoạn
                do bảo trì, nâng cấp hoặc sự cố từ bên thứ ba (sàn TMDT, đơn vị vận chuyển).
                Bạn sử dụng dịch vụ theo đúng mục đích: quản lý bán hàng đa kênh, đồng bộ đơn hàng
                và vận chuyển. Không được sử dụng dịch vụ để phát tán nội dung vi phạm pháp luật,
                lừa đảo hoặc xâm phạm quyền của người khác.
              </p>

              <h2>4. Thanh toán</h2>
              <p>
                Các gói dịch vụ và phí (nếu có) sẽ được công bố trên nền tảng. Bạn chịu trách nhiệm
                thanh toán đúng hạn theo chính sách hiện hành. Phí dịch vụ vận chuyển (GHN, VTP, Grab, v.v.)
                do đơn vị vận chuyển quy định; connect.mybota.vn chỉ là nền tảng kết nối và không định giá cước.
              </p>

              <h2>5. Trách nhiệm</h2>
              <p>
                Chúng tôi (Bota.vn) cung cấp nền tảng kỹ thuật connect.mybota.vn để bạn kết nối sàn và đơn vị vận chuyển.
                Chúng tôi không chịu trách nhiệm về nội dung bạn đăng tải, giao dịch giữa bạn
                và khách hàng, hoặc tranh chấp với sàn/đơn vị vận chuyển. Trong phạm vi pháp luật
                cho phép, trách nhiệm của Bota.vn (connect.mybota.vn) giới hạn ở việc khôi phục dịch vụ hoặc hoàn trả
                phí dịch vụ đã thanh toán (nếu có) trong trường hợp lỗi từ phía chúng tôi.
              </p>

              <h2>6. Chấm dứt</h2>
              <p>
                Bạn có thể ngừng sử dụng dịch vụ và yêu cầu xóa tài khoản bất cứ lúc nào.
                Chúng tôi có quyền tạm ngừng hoặc chấm dứt cung cấp dịch vụ cho tài khoản vi phạm
                điều khoản hoặc chính sách. Sau khi chấm dứt, quyền truy cập của bạn vào dữ liệu
                trên nền tảng sẽ bị thu hồi theo chính sách lưu trữ và xóa dữ liệu.
              </p>

              <h2>7. Thay đổi điều khoản</h2>
              <p>
                Chúng tôi có thể cập nhật điều khoản dịch vụ khi cần. Thay đổi quan trọng sẽ được
                thông báo qua email hoặc thông báo trên nền tảng. Việc tiếp tục sử dụng dịch vụ
                sau khi điều khoản được cập nhật đồng nghĩa với việc bạn chấp nhận các thay đổi đó.
              </p>

              <h2>8. Liên hệ</h2>
              <p>
                Mọi thắc mắc về điều khoản dịch vụ, vui lòng liên hệ:
              </p>
              <ul>
                <li><strong>Email:</strong> contact@bota.com.vn</li>
                <li><strong>Hỗ trợ:</strong> 1900 2008</li>
                <li><strong>Hotline:</strong> 0988 512 772</li>
                <li><strong>Website:</strong> connect.mybota.vn / bota.vn</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <footer className='legal-page-footer'>
        <div className='legal-page-footer-inner'>
          <div className='legal-page-copyright'>
            Copyright &copy; 2023 bota.vn — connect.mybota.vn · Giải pháp quản lý và bán hàng đa kênh toàn diện
          </div>
          <div className='legal-page-links'>
            <a href='/privacy-policy'>Chính sách quyền riêng tư</a>
            <a href='/terms-of-service'>Điều khoản dịch vụ</a>
          </div>
        </div>
      </footer>
    </div>
  );
}
